<!-- Fleet Status Modal -->
<div class="modal fade" id="safetyDashboardModal" tabindex="-1" aria-labelledby="safetyDashboardModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <h5 class="modal-title" id="safetyDashboardModalLabel">داشبورد وضعیت ناوگان</h5>
            </div>
            <div class="modal-body p-0" style="max-height: 81vh;overflow: auto;">
                <app-fleet-status></app-fleet-status>
            </div>
        </div>
    </div>
</div>
